import { Pipe, PipeTransform } from '@angular/core';
import { TEMPERATURE_UNITS } from '../lib/units';

@Pipe({ name: 'temperatureDeviation' })
export class TemperatureDeviationPipe implements PipeTransform {
  /**
   * Transforms the given temperature based on the specified units.
   *
   * @param {number} temperature - The temperature value to be transformed.
   * @param {boolean} useMetricUnits - A flag indicating whether to use metric units (Celsius) for the transformation.
   * @param {string} currentDataUnits - The current units of the temperature value,
   *  expected to be either 'Celsius' or 'Fahrenheit'.
   * @returns {number} - The transformed temperature value.
   *  If the currentDataUnits are not supported, the original temperature is returned.
   *
   * @remarks
   * - If `useMetricUnits` is `false` and `currentDataUnits` is 'Celsius', the temperature is converted to Fahrenheit.
   * - If `useMetricUnits` is `true` and `currentDataUnits` is 'Fahrenheit', the temperature is converted to Celsius.
   * - If `currentDataUnits` is neither 'Celsius' nor 'Fahrenheit', a warning is logged and the original temperature is returned.
   */
  public transform(temperature: number, useMetricUnits: boolean, currentDataUnits: string): number {
    if (!useMetricUnits && currentDataUnits === TEMPERATURE_UNITS.CELSIUS) {
      return temperature * 9 / 5;
    } else if (useMetricUnits && currentDataUnits === TEMPERATURE_UNITS.FAHRENHEIT) {
      return temperature * 5 / 9;
    } else if (currentDataUnits !== TEMPERATURE_UNITS.CELSIUS && currentDataUnits !== TEMPERATURE_UNITS.FAHRENHEIT) {
      console.warn('Detected a temperature conversion argument which is not supported, returning result as it was passed');
    }
    return temperature;
  }
}
